import React from 'react';

const MediumButton = (props) =>{
    return(
        <>
        <button className='btn-customization md-btn'>
            {props.Title}
        </button>
        </>
    )
}

export default MediumButton;